var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('drives'),(_vm.medias.length)?_c('folders',{class:_vm.selectedViewToggle,attrs:{"folders":_vm.medias}}):_c('span',[_vm._v("Aucun Dossier n'a été crée")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }